import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthState} from '@aws-amplify/ui-components';
import {SessionService} from './session.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
    constructor(
        private router: Router,
        private sessionService: SessionService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.sessionService.authState != AuthState.SignedIn) {
            this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
            return false;
        }

        return true;
    }
}